import { Page, PageHeader } from '@/shared/ui/page';
import { TabsComponent as Tabs } from '@noorden-insurtech/alba-design-system';
import { Home } from 'lucide-react';
import { PremiosEmitidosTab } from './premios-emitidos/premios-emitidos-tab.component';
import { ExtratoParcelasTab } from './extrato-parcelas/extrato-parcelas-tab.component';

export function ReportsPage() {
  return (
    <Page.Root>
      <Page.Breadcrumb
        items={[
          { label: 'Página Inicial', href: '/dashboard', iconLeft: <Home className='h-4 w-4' /> },
          { label: 'Gestão de Carteira', active: true },
        ]}
      />

      <PageHeader.Root>
        <PageHeader.Main>
          <PageHeader.TitleGroup>
            <PageHeader.Title>Gestão de Carteira</PageHeader.Title>
            <PageHeader.Subtitle>Acompanhe e gerencie sua carteira</PageHeader.Subtitle>
          </PageHeader.TitleGroup>
        </PageHeader.Main>
      </PageHeader.Root>

      <Page.Content className='min-w-0'>
        <Tabs.Root defaultValue='emitidos'>
          <Tabs.List className='w-full'>
            <Tabs.Trigger value='emitidos' className='flex-1 justify-center'>
              Prêmios Emitido
            </Tabs.Trigger>
            <Tabs.Trigger value='parcelas' className='flex-1 justify-center'>
              Extrato de Parcelas
            </Tabs.Trigger>
            <Tabs.Indicator />
          </Tabs.List>

          <Tabs.Content value='emitidos' className='pt-6'>
            <PremiosEmitidosTab />
          </Tabs.Content>

          <Tabs.Content value='parcelas' className='pt-6'>
            <ExtratoParcelasTab />
          </Tabs.Content>
        </Tabs.Root>
      </Page.Content>
    </Page.Root>
  );
}
